
import { extendTheme } from '@chakra-ui/react'
const theme = {
}

export default extendTheme(theme)